import { attr, hasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const DeliveryAddresses = ApplicationRecord.extend({
  attrs: {
    country_code: attr(),
    delivery_instructions: attr(),
    locality: attr(),
    postcode: attr(),
    recipient_email: attr(),
    recipient_name: attr(),
    recipient_phone: attr(),
    street_1: attr(),
    street_2: attr(),
    street_3: attr(),
    customer: hasOne({ type: 'customers-customers', persist: false }),
  },
  static: {
    endpoint: '/delivery_addresses',
    jsonapiType: 'customers-delivery_addresses',
  },
});

export default DeliveryAddresses;
